<template>
  <div class="inline-block">
    <slot v-bind="{ openModal }"/>

    <modal
      as="form"
      class="mb-0"
      :show="showModal"
      scrollable
      @close="closeModal"
      @reset.prevent="closeModal"
    >
      <template #title>
        Create budget
      </template>
      <template #body>
        <budget-create-form :model-value="modelValue" :items="items"/>
      </template>
    </modal>
  </div>
</template>

<script setup>
import BudgetCreateForm from "@/components/forms/BudgetCreateForm.vue"
import Modal from "@/components/modals/Modal.vue"
import { computed, ref } from "vue"

const props = defineProps({
  items: { type: Array },
  modelValue: { type: Object },
})

const items = computed(() => props.items?.map((i) => ({ ...i, starred: i.in_list })))

const showModal = ref(false)

const openModal = () => {
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}
</script>
